module.exports = __webpack_public_path__ + "static/images/check-sparkle.3295b84794c3278a167f29d957a4785e.svg";